import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClaim } from "../../entity/EntityClaim";

export class DtoClaimsGetRes extends EntityClaim {
  public items: EntityClaim[]  = [];
}
